import React from 'react';

import isEmpty from 'lodash/isEmpty';

import { useParams } from '@gogame/screens';

import { ViewStateContext } from '../ViewStateContext';

const getIndexPathByIds = (pathIds, { nodes }) => {
  if (isEmpty(pathIds) || isEmpty(nodes)) {
    return '';
  }

  const [id, ...ids] = pathIds;
  const index = nodes.findIndex((node) => node.entityId === Number(id));
  if (index === -1) {
    return '';
  }

  return `nodes[${index}]${
    !isEmpty(ids) ? `.${getIndexPathByIds(ids, nodes[index])}` : ''
  }`;
};

export const useParamsPathName = (length) => {
  const values = React.useContext(ViewStateContext);
  const params = useParams();

  const {
    network,
    application,
    channel,
    platform,
    affiliate,
    country,
    manager,
  } = params;
  const pathIds = [
    network,
    application,
    channel,
    platform,
    affiliate,
    country,
    manager,
  ]
    .slice(0, length)
    .filter((i) => i);

  return getIndexPathByIds(pathIds, values);
};
